import type { HidChannel } from '../../../channels/hid/HidChannel'
import { DeviceManifest } from '../../../types/manifest'
import { BaseDevice } from '../../../runtime/BaseDevice'
import { TELINK_BASE_PROFILE } from '../../../chips/telink/protocols/base-command'
import { TelinkBaseFirmware } from '../../../chips/telink/feature-impls/base/firmware'
import { installBaseDockFeatures } from '../support/composition/installBaseDockFeatures'
import { BaseChildReportService } from '../support/services/BaseChildReportService'

/** P5/P6 等 Telink_Base 协议底座驱动。 */
export class TelinkBaseDevice extends BaseDevice {
  /** 当前底座型号装配的 Telink 底座芯片能力。 */
  private readonly baseChipProfile = TELINK_BASE_PROFILE
  private readonly childReports = new BaseChildReportService(this, this.baseChipProfile)

  constructor(channel: HidChannel, manifest: DeviceManifest) {
    super(channel, manifest)
    installBaseDockFeatures({
      device: this,
      profile: this.baseChipProfile,
    })
    this.features.firmware = new TelinkBaseFirmware(this, this.baseChipProfile)
  }

  protected onConnected(): void {
    console.log(`[TelinkBaseDevice] Connected: ${this.manifest.model}`)
  }

  /**
   * 主动透传读取当前配对子鼠标并同步逻辑子设备。
   * 与 Nordic 底座一致：仅一次性调用，不做周期轮询。
   */
  public emitCurrentConnectedMouse(): Promise<void> {
    return this.childReports.emitCurrentConnectedMouse()
  }

  /** 处理 Telink 底座主动上报。 */
  protected handleReport(_reportId: number, data: DataView): void {
    // Telink 底座的主动上报 payload 从 byte0 开始，直接转成统一 child report。
    this.childReports.emitReport(data)
  }
}
